<script lang="ts" setup>
import abbreviationLogo from '~/assets/icons/logo/abbreviation.svg?url';
import nameLogo from '~/assets/icons/logo/name.svg?url';

const props = defineProps<{
  path: string;
}>();

const { t } = useI18n();

const { data: page, error } = await useAsyncData(props.path, () =>
  queryCollection('page').path(`/${props.path}`).first(),
);

if (!page.value || error.value) {
  throw createError({ statusCode: 404 });
}

useSeoMeta({
  title: `${t('company.brand_name')} — ${page.value.title}`,
  ogTitle: `${t('company.brand_name')} — ${page.value.title}`,
});
</script>

<template>
  <main class="blogPageLayout">
    <div class="blogPageLayout__container">
      <NuxtLink to="/" class="blogPageLayout__link">
        <picture>
          <source :srcset="nameLogo" media="(min-width: 1240px)" />
          <img
            :src="abbreviationLogo"
            alt="Don't Touch My Skin"
            class="blogPageLayout__logo"
          />
        </picture>
      </NuxtLink>

      <div class="blogPageLayout__content">
        <ContentRenderer v-if="page" :value="page" class="articleComponent" />
      </div>
    </div>
    <SectionSubscribe />
  </main>
</template>

<i18n src="~/locales/company.yaml" />

<style lang="scss" src="@/assets/styles/article.component.scss"></style>

<style lang="scss">
.blogPageLayout {
  &__container {
    padding: 20px;
  }

  &__link {
    display: block;
    width: fit-content;
    margin-bottom: 28px;
  }

  &__logo {
    width: 161px;
    filter: invert(1);

    @include mq('lg') {
      width: 188px;
      filter: initial;
    }

    @include mq('sm') {
      width: 121px;
    }
  }

  &__content {
    margin: 0 auto;
    max-width: 700px;
    padding-bottom: 40px;
  }
}
</style>
